import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui";
import { EmptyState } from "@/shared/components";
import type { ChatChannel } from "../types";
import ChatSidebarItem from "./ChatSidebarItem";

interface ChatSidebarProps {
  channels: ChatChannel[];
  selectedChannelId: number | null;
  onSelectChannel: (id: number) => void;
  canManage: boolean;
  onManageClick: () => void;
}

export default function ChatSidebar({
  channels,
  selectedChannelId,
  onSelectChannel,
  canManage,
  onManageClick,
}: ChatSidebarProps) {
  const { t } = useTranslation("ChatPage");

  return (
    <div className="flex flex-col h-full surface-base-fill border-r surface-component-stroke">
      <div className="px-6 py-4 border-b surface-component-stroke shrink-0">
        <h2 className="text-heading-md content-base-primary">{t("sidebar.title")}</h2>
      </div>
      <div className="flex-1 overflow-y-auto component-scroll-thin p-3 flex flex-col gap-1 min-h-0">
        {channels.length === 0 ? (
          <EmptyState compact noDataText={canManage ? t("sidebar.empty") : t("sidebar.noAccess")} />
        ) : (
          channels.map((channel) => (
            <ChatSidebarItem
              key={channel.id}
              channel={channel}
              isActive={channel.id === selectedChannelId}
              onClick={onSelectChannel}
            />
          ))
        )}
      </div>
      {canManage && (
        <div className="p-3 shrink-0">
          <Button size="lg" variant="tertiary" onClick={onManageClick} className="w-full">
            {t("manageChannels")}
          </Button>
        </div>
      )}
    </div>
  );
}
